import api from "./api";

const banners = `mocks${import.meta.env.VITE_BASE_PATH}banners.shop.json`;
let cachedResponse = null;

class BannerShopService {
	async get() {
		if (!cachedResponse) {
			const resp = await fetch(banners);
			cachedResponse = await resp.json();
		}

		return cachedResponse;
	}
}

export default new BannerShopService();
